export const DEFAULT_UPLOAD_ERROR_MESSAGE = 'Failed to upload attachment';

export const readDirectUploadErrorMessage = (
  xhr: XMLHttpRequest
): string | null => {
  // ActiveStorage blob creation uses responseType "json"; prefer xhr.response
  // over responseText (responseText can throw InvalidStateError on iOS WebKit).
  const response = xhr.response as { errors?: string[] } | null;
  if (Array.isArray(response?.errors)) return response.errors.join(', ');

  try {
    const responseText = xhr.responseText;
    if (!responseText) return null;

    const parsed = JSON.parse(responseText);
    return parsed.errors?.join(', ') || parsed.error || parsed.message || responseText;
  } catch {
    return null;
  }
};
